import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useEventListener } from '@beef/react';
import React from 'react';
var findAncestorWithTagName = function findAncestorWithTagName(node, tagName) {
  while (node && node.tagName !== 'BODY') {
    if (node.tagName === tagName) return node;
    node = node.parentNode;
  }
  return null;
};
var useSmartAnchors = function useSmartAnchors(actions) {
  useEventListener('click', function (event) {
    var anchor = findAncestorWithTagName(event.target, 'A');
    if (!anchor) return;
    var href = anchor.getAttribute('href');
    if (!href) return;
    actions.some(function (_ref) {
      var regex = _ref.regex,
        action = _ref.action;
      var matches = href.match(regex);
      if (matches) {
        event.preventDefault();
        action.apply(void 0, _toConsumableArray(matches.slice(1)));
        return true; // Прекращаем выполнение после первого совпадения
      }

      return false;
    });
  }, typeof document !== 'undefined' ? document.body : undefined);
};
export var withSmartAnchors = function withSmartAnchors(actions) {
  return function (Component) {
    return function (props) {
      useSmartAnchors(actions);
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        "data-t-id": "utils-enhancers"
      }));
    };
  };
};